<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Caneta_1920x324.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Caneta de Avaliação de Pintura</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="content">
        <div class="left">
          <div class="ckeditor">
            <p>Pintura e reparos na lataria não precisam mais ser um assunto delicado. Pra quem precisa daquela ajuda
              extra para identificar originalidade, repintura ou reparos em massa plástica e outros materiais, a Caneta
              de Avaliação de Pintura é o caminho. Uma ferramenta exclusiva Union, que conta com um Medidor Magnético
              que realiza a verificação de forma rápida, prática e segura.</p>
          </div>
          <figure class="fig_mobile">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/MicrosoftTeams-image.png"
              alt="Microsoft Teams Image Mobile" loading="lazy">
          </figure>
          <div class="button">
            <a class="btn gradient" href="compra">Comprar</a>
          </div>
        </div>
        <div class="right">
          <figure class="fig">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/MicrosoftTeams-image.png"
              alt="Microsoft Teams Image" loading="lazy">
          </figure>
        </div>
      </div>

    </div>
  </section>

  <section class="wrap-vcl">
    <div class="layout">
      <div class="box">
        <div class="content vcl-content">
          <div class="vcl-media">
            <div class="institucional__video">
            <video #institucionalVideo class="institucional__player" controls preload="metadata" playsinline muted
              aria-label="Vídeo institucional da Carcheck Brasil">
              <source src="https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/CANETA_AVALIA%C3%87%C3%83O_COM_TRILHA.mp4"
                type="video/mp4" />
              Seu navegador não suporta reprodução de vídeo.
            </video>
            </div>
          </div>
          <div class="list-topics vcl-topics">
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/fab.png"
                  alt="Fabricação exclusiva" loading="lazy">
              </div>
              <div class="text">
                <p>Fabricação exclusiva e nacional;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/aluminio.png"
                  alt="Estrutura de qualidade em alumínio" loading="lazy">
              </div>
              <div class="text">
                <p>Estrutura de qualidade em alumínio;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/manutencao.png"
                  alt="Manutenção" loading="lazy">
              </div>
              <div class="text">
                <p>Permite manutenção de peças e recalibragem;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/garantia.png"
                  alt="Garantia" loading="lazy">
              </div>
              <div class="text">
                <p>Garantia contra defeitos de fabricação;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/vistoria.png"
                  alt="Vistoria" loading="lazy">
              </div>
              <div class="text">
                <p>Ideal para a vistoria de automóveis.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-contact-box></app-contact-box>

</main>
